export const vision = {
  id: '1',
  visiondata: 'To nurture and empower the next generation of innovators and entrepreneurs by providing a supportive and resource-rich environment that transforms ideas into sustainable ventures.'
};

export const edc_logo = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/EDC/EDC_logo.webp"

export const mission_data = [
  {
    id: '1',
    mission: 'To provide a structured approach for developing and executing innovative projects and start-up ideas.'
  },
  {
    id: '2',
    mission: 'To ensure clear visibility of progress and milestones in entrepreneurial ventures.'
  },
  {
    id: '3',
    mission: 'To help students set priorities effectively in order to manage multiple projects and opportunities.'
  },
  {
    id: '4',
    mission: 'To enhance professional skills such as business planning, market research, and networking.'
  }

]

